/* eslint-disable func-call-spacing */
const Index = () => import('~pages/Project/Members/Index.vue')
const NavBar = () => import('~components/navbar/NavBar.vue')
const AddMembersDialog = () => import('~pages/Project/Members/AddMembersDialog.vue')

export default [
  {
    path: '/:project/members',
    name: 'members',
    components: {
      default: Index,
      navbar: NavBar
    },
    meta: {
      access: ['project.view', 'org.project.view']
    },
    children: [
      {
        name: 'members-add',
        path: 'add',
        components: {
          modal: AddMembersDialog
        },
        meta: {
          showModal: true,
          access: ['project.manage', 'org.project.view']
        }
      }
    ]
  }
]
